// extracted by mini-css-extract-plugin
export var typingIndicator = "_p9-0";